/**
 * 車両の充電のタイプ.
 */
export const VehicleChargeType = {
  /** disabled : 無効. */
  DISABLED: 'disabled',
  /** enabled : 有効. */
  ENABLED: 'enabled'
};

export type VehicleChargeType = typeof VehicleChargeType[keyof typeof VehicleChargeType];

/**
 * 車両の充電のドロップダウンのリスト.
 */
export const VehicleChargeTypeDropDownList = [
  { key: VehicleChargeType.DISABLED + ':無効', value: VehicleChargeType.DISABLED },
  { key: VehicleChargeType.ENABLED + ':有効', value: VehicleChargeType.ENABLED }
];

/**
 * 車両の充電の一覧表示用のリスト.
 */
export const VehicleChargeTypeListViewMap = new Map<VehicleChargeType, string>(
  [
    [VehicleChargeType.DISABLED, '無効'],
    [VehicleChargeType.ENABLED, '有効'],
  ]
);


// WEBPACK FOOTER //
// ./src/types/vehicle-charge-type.ts